import * as React from 'react';
import * as Modal from 'react-modal';

export interface IConfirmModalProps {
  isOpen: boolean;
  title?: string | React.ReactElement<any>;
  children?: any;
  onClose: (result: boolean) => void;
  rightButtonText?: string;
  leftButtonText?: string;
}

export const ConfirmModal: React.StatelessComponent<IConfirmModalProps>
= ({isOpen, title, children, onClose, rightButtonText, leftButtonText}: IConfirmModalProps) => (
  <Modal {...{
    isOpen,
    className: 'confirm-modal-component',
    overlayClassName: 'confirm-modal-component_overlay',
    contentLabel: 'ConfirmModal',
    ariaHideApp: false,
    onRequestClose: () => onClose(false),
  }}>
    <div className={'confirm-modal-component__wrapper'}>
      <div className={'confirm-modal-component__header'}>
        {
          title &&
          <div className={'confirm-modal-component__title'}>{title}</div>
        }
        <span className={'btn--close'} onClick={() => onClose(false)}>
          <span className={'icon icon--close'} />
        </span>
      </div>
      <div className={'confirm-modal-component__body'}>
        {children}
      </div>
      <div className={'confirm-modal-component__controls'}>
        <button className={'btn btn_transparent btn_cancel'} onClick={() => onClose(false)}>
          {leftButtonText || 'Cancel'}
        </button>

        <button className={'btn btn_transparent btn_confirm'} onClick={() => onClose(true)}>
          {rightButtonText || 'Confirm'}
        </button>
      </div>
    </div>
  </Modal>
);
